import React from 'react'


function ManWoman() {

  return (
    <div>
      <button className='peer text-white lg:text-gray-700 font-semibold lg:font-normal text-center  text-md   lg:text-sm'>Kadın & Erkek</button>

      <div className='hidden peer-hover:flex hover:flex absolute '>
<div className='p-2 md:p-3 lg:p-4 z-20 rounded-xl bg-gradient-to-r from-purple-500 to-pink-500 w-80 md:w-97 lg:w-90 border border-gray-400 lg:border-none mt-2 lg:mt-6 text-center cursor-pointer '>
<div  className=" p-1 lg:p-2 space-x-2 grid grid-cols-2 md:grid-cols-3">
       
        <ul className='space-y-1 text-gray-700 text-xs md:text-sm font-[500] mt-2 ' >
    
        <h6 className='text-xs  md:text-sm font-[500] text-gray-300 underline'>Erkek Giyim</h6>
            <li className="hover:text-violet-700 duration-500 hover:underline">Elbise</li>
            <li className="hover:text-violet-700 duration-500 hover:underline">T-Shirt</li>
            <li className="hover:text-violet-700 duration-500 hover:underline">Gömlek</li>
            <li className="hover:text-violet-700 duration-500 hover:underline">Pantolon</li>
            <li className="hover:text-violet-700 duration-500 hover:underline">Ceket,Kaban,Mont</li>
            <li className="hover:text-violet-700 duration-500 hover:underline">SweatShirt</li>
            <li className="hover:text-violet-700 duration-500 hover:underline">Triko & Kazak</li>
            <li className="hover:text-violet-700 duration-500 hover:underline">Eşofman</li><li className="hover:text-violet-700 duration-500 hover:underline">Şort</li>
            <li className="hover:text-violet-700 duration-500 hover:underline">Takım Elbise</li><li className="hover:text-violet-700 duration-500 hover:underline">Erkek Kot Pantolon</li>
            <li className="hover:text-violet-700 duration-500 hover:underline">Erkek Çocuk</li>

        </ul>
               
        <ul className='space-y-1 text-gray-700 text-xs  md:text-sm font-[500] mt-2 ' >
     
     <h6 className='text-xs  md:text-sm font-[500] text-gray-300 underline'>Kadın Giyim</h6>
         <li className="hover:text-violet-700 duration-500 hover:underline">Kaban, Mont</li>
         <li className="hover:text-violet-700 duration-500 hover:underline">Sweatshirt</li>
         <li className="hover:text-violet-700 duration-500 hover:underline">Gömlek</li>
         <li className="hover:text-violet-700 duration-500 hover:underline">Pantolon</li>
         <li className="hover:text-violet-700 duration-500 hover:underline">Ceket,Kaban</li>
         <li className="hover:text-violet-700 duration-500 hover:underline">Tayt</li>
       <li className="hover:text-violet-700 duration-500 hover:underline">Triko & Kazak</li>
       <li className="hover:text-violet-700 duration-500 hover:underline">Bluz</li>
       <li className="hover:text-violet-700 duration-500 hover:underline">Etek</li><li className="hover:text-violet-700 duration-500 hover:underline">Hamile Giyip</li><li className="hover:text-violet-700 duration-500 hover:underline">Tesettür</li>
       <li className="hover:text-violet-700 duration-500 hover:underline">Kız Çocuk</li>
     </ul>
        <ul className='space-y-1 text-gray-700 text-xs  md:text-sm font-[500] mt-2'>
        <h6 className='text-xs  md:text-sm font-[500] text-gray-200 underline'>Erkek Aksesuar</h6>
            <li className="hover:text-violet-700 duration-500 hover:underline">Saat</li>
            <li className="hover:text-violet-700 duration-500 hover:underline">Güneş Gözlüğü</li>
            <li className="hover:text-violet-700 duration-500 hover:underline">Takı</li>
            <li className="hover:text-violet-700 duration-500 hover:underline">Kol Düğmesi</li>
            <li className="hover:text-violet-700 duration-500 hover:underline">Kemer</li>
            <li className="hover:text-violet-700 duration-500 hover:underline">Şapka</li>
            <li className="hover:text-violet-700 duration-500 hover:underline">Cüzdan</li>
        </ul>
        <ul className='space-y-1 text-gray-700 text-xs  md:text-sm font-[500] mt-2'>
        <h6 className='text-xs  md:text-sm font-[600] text-gray-200 underline'>Kadın Aksesuar</h6>
            <li  className="hover:text-violet-700 duration-500 hover:underline">Saat</li>
            <li  className="hover:text-violet-700 duration-500 hover:underline">Güneş Gözlüğü</li>
            <li  className="hover:text-violet-700 duration-500 hover:underline">Mücevherat</li>
            <li  className="hover:text-violet-700 duration-500 hover:underline">Takı Bijuteri</li>
        </ul>
        <ul className='space-y-1 text-gray-700 text-xs  md:text-sm font-[500] mt-2' >
        <h6 className='text-xs  md:text-sm font-[500] text-gray-300 underline'> Erkek Ayakkabı</h6>
            <li className="hover:text-violet-700 duration-500 hover:underline">Günlük Ayakkabı</li>
            <li className="hover:text-violet-700 duration-500 hover:underline">Bot</li>
            <li className="hover:text-violet-700 duration-500 hover:underline">Klasik Ayakkabı</li>
            <li className="hover:text-violet-700 duration-500 hover:underline">Outdoor</li>
            <li className="hover:text-violet-700 duration-500 hover:underline">Spor Ayakkabı</li>
            <li className="hover:text-violet-700 duration-500 hover:underline">Erkek Sandalet, Terlik</li>
          
   <li className="hover:text-violet-700 duration-500 hover:underline">Erkek Çocuk Ayakkabıları</li>
       

        </ul>



       
   


        <ul className='space-y-1 text-gray-700 text-xs  md:text-sm font-[500] ' >
        <h6 className=' font-[500] text-gray-300 underline'> Kadın Ayakkabı</h6>
            <li className="hover:text-violet-700 duration-500 hover:underline">Günlük Ayakkabı</li>
            <li className="hover:text-violet-700 duration-500 hover:underline">Bot</li>
            <li className="hover:text-violet-700 duration-500 hover:underline">Klasik Ayakkabı</li>
            <li className="hover:text-violet-700 duration-500 hover:underline">Outdoor</li>
            <li className="hover:text-violet-700 duration-500 hover:underline">Topuklu Ayakkabı</li>
            <li className="hover:text-violet-700 duration-500 hover:underline">Kadın Çizme, Bot</li>
            <li className="hover:text-violet-700 duration-500 hover:underline">Kadın  Sandalet, Terlij</li>
            <li className="hover:text-violet-700 duration-500 hover:underline">Spor Ayakkabı</li>
     
 <li className="hover:text-violet-700 duration-500 hover:underline">Kız Çocuk Aykkabıları</li>

       

        </ul>
     </div>




    
  
</div>
 
     

      </div>
    </div>
  )
}

export default ManWoman
